export default __webpack_public_path__ + "static/media/t-shirt.a09bb8af.png";